import React from 'react'

import type { MutableRefObject } from 'react'

import { NEW_VERSION_BAR_HEIGHT_PROPERTY } from '@constants'

import { useWindowWidth } from './useWindowWidth'

export function useSticky(top: number): [boolean, MutableRefObject<Nullable<HTMLDivElement>>] {
  const appBarRef = React.useRef<Nullable<HTMLDivElement>>(null)
  const [sticky, setSticky] = React.useState(false)
  const isDesktop = useWindowWidth(1200)

  React.useLayoutEffect(() => {
    function scrollDetector() {
      const el = appBarRef.current
      if (el) {
        const rect = el.getBoundingClientRect()
        const newVersionBarHeight =
          parseFloat(document.documentElement.style.getPropertyValue(NEW_VERSION_BAR_HEIGHT_PROPERTY)) || 0
        setSticky(isDesktop && rect.top < top + newVersionBarHeight)
      }
    }
    window.addEventListener('scroll', scrollDetector)
    return () => {
      window.removeEventListener('scroll', scrollDetector)
    }
  }, [isDesktop, top])

  return [sticky, appBarRef]
}
